module.exports = {"632722100":"萨呼腾镇","632722200":"昂赛乡","632722201":"结多乡","632722202":"阿多乡","632722203":"苏鲁乡","632722204":"查旦乡","632722205":"莫云乡","632722206":"扎青乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632722.json
// module id = 3012
// module chunks = 0